var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2WineCellarBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v29H51V34c0-6.49 5-6.71 5-9.71V13h4v11.31c0 3 5 3.22 5 9.69zm-25-9.69V13h-4v11.31c0 3-5 3.22-5 9.71V63h14V34c0-6.47-5-6.69-5-9.69zm-20 0V13h-4v11.31c0 3-5 3.22-5 9.71V63h14V34c0-6.47-5-6.69-5-9.69z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Wine_cellar_bis.32dba7dc.svg";
export { SvgE2WineCellarBis as ReactComponent };